// src/components/Configurator/renderers/SwitchRenderer.jsx
import React from "react";
import { SELECTED_ELEMENT_COLOR, defaultObjectSizes, OBJECT_TYPES } from "../configuratorConstants";
import { ReactComponent as SwitchX1Svg } from '../../Assets/switchx1.svg';

const SwitchRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness, // in meters
  placementSideFactor, // Should be 1 (e.g., top/right wall) or -1 (e.g., bottom/left wall)
}) => {
  const switchDefaults = defaultObjectSizes[OBJECT_TYPES.SWITCH];
  const elementVisualWidthM = element.width || switchDefaults.width;
  const elementVisualHeightM = element.height || switchDefaults.height;
  const elementDepthM = element.depth || switchDefaults.depth || 0.01;

  const elementVisualWidthPx = elementVisualWidthM * scale;
  const elementVisualHeightPx = elementVisualHeightM * scale;

  const wallThicknessPx = wallThickness * scale;
  const elementDepthPx = elementDepthM * scale;
  
  const yOffset = placementSideFactor * ( (wallThicknessPx / 2) + (elementDepthPx / 2) );

  const svgStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : "rgba(229, 231, 235, 0.95)",
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "rgba(107, 114, 128, 0.8)",
    strokeWidth: isSelected ? 1.2 / (scale / 50) : 0.6 / (scale / 50),
    transition: "fill 0.1s ease-out, stroke 0.1s ease-out",
  };

  let svgSpecificTransform = "";
  if (placementSideFactor === 1) {
    // Для правой и верхней стены (где dPSF = 1), если они выглядят неправильно,
    // применяем поворот на 180 градусов.
    svgSpecificTransform = "rotate(0)"; // Эквивалентно scale(-1, -1)
  } else if (placementSideFactor === -1) {
    // Для левой и нижней стены (где dPSF = -1), если левая стена была "хорошо",
    // это обычно достигалось отражением по Y.
    svgSpecificTransform = "scale(1, -1)";
  }

  return (
    <g transform={`translate(0, ${yOffset})`}>
      <g transform={svgSpecificTransform}>
        <SwitchX1Svg
          x={-elementVisualWidthPx / 2} 
          y={-elementVisualHeightPx / 3.7}
          width={elementVisualWidthPx / 1.2}
          height={elementVisualHeightPx}
          preserveAspectRatio="xMidYMid meet"
          style={svgStyle}
        />
      </g>
    </g>
  );
};

export default React.memo(SwitchRenderer);